/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onClosePop, onLoadData } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sName, setSname] = useState(""); //*
  const [tcid, setTcid] = useState(""); //*
  const [title, setTitle] = useState(""); //*
  const [tmcd, setTmcd] = useState(""); //*
  const [message, setMessage] = useState(""); //*
  const [type, setType] = useState("선택회원") //*

  const onSubmit = async () => {

    let result = await axios.post(
      configState.api + "/push/send_notice",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        tcid: tcid,
        type:type,
        tmcd: tmcd,        
        title:title,
        message: message,
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
        (result) => {
          onLoadData();
          onClosePop();
        }
      );
    }
  };

  const onCidChange = (e) => {
    pr("cid change");
  };

  const handleClose = () => {};

  // MemberSearch
  const onShowMemberSearchClick = () => {
    setShowMemberSearch(true);
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setTmcd(id);
  };

  return (
    <Box>
      
      {/* 사용자 팝업 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      <Box
      sx={{p:2}}        
      >
        {/* 센터명 */}
        <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            /> 
        
        {/* 결제방식 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>발송구분</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="type"
            value={type}
            onChange={(e)=>{setType(e.target.value)}}
            >
            <FormControlLabel value="선택회원" control={<Radio />} label="선택회원" />

            { login.level === '500' &&
            <FormControlLabel value="모든회원" control={<Radio />} label="모든회원" />
            }
            
          </RadioGroup>
        </FormControl>   

        {/* 고객명 */}
        { type==="선택회원" &&
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={sName}
          ></TextField>

          <Button
            variant="contained"
            sx={{ ml: 1 }}
            onClick={onShowMemberSearchClick}
          >
            조회
          </Button>
        </Box> }

        {/* 제목 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <FormControl
            sx={{
              width: '180px'
            }}>
            <InputLabel>카테고리</InputLabel>
            <Select
              size='small'
              label='카테고리'
              value={title}
              onChange={(e) => setTitle(e.target.value)}>
              <MenuItem value='공지'>공지</MenuItem>
              <MenuItem value='이벤트'>이벤트</MenuItem>
              <MenuItem value='쿠폰'>쿠폰</MenuItem>
              <MenuItem value='예약'>예약</MenuItem>
              <MenuItem value='심박'>심박</MenuItem>
              <MenuItem value='캐시'>캐시</MenuItem>
              <MenuItem value='출석'>출석</MenuItem>
            </Select>
          </FormControl>
          {/* <TextField
            name="title"
            label="제목"
            size="small"
            autoComplete="off"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth            
          ></TextField> */}
        </Box>

        {/* 메세지 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="message"
            label="메세지"
            size="small"
            multiline
            autoComplete="off"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            rows={4}
          ></TextField>
        </Box>        

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            발송완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
